export default __webpack_public_path__ + "6668ab8b8efbd5d602b038192993829c.svg";